var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8485 3L1.81646 4.03023L8.71715 11.3104V14.3533H12.7745V11.7102L2.8485 3ZM1.52724 5.08435V9.2541L1.73584 9.3943C2.28514 9.75779 2.50258 10.1265 2.56448 10.4225C2.62586 10.7236 2.54211 10.9833 2.36421 11.1962C2.00737 11.6272 1.32854 11.8349 0.661667 11.165L0 11.8297C0.997703 12.8215 2.39958 12.6138 3.0831 11.7985C3.42538 11.3883 3.60172 10.8171 3.48103 10.2355C3.3744 9.71625 3.02744 9.21255 2.46357 8.78156V6.07097L1.52724 5.08435ZM14.9489 7.81052V15.288H5.32559C6.50119 15.5892 7.43751 16.5083 7.75482 17.6767H16.2129C16.6031 16.2435 17.9191 15.1842 19.4744 15.1842C21.0298 15.1842 22.3458 16.2435 22.736 17.6767H24V13.2836L20.8685 7.81052H14.9489ZM16.8215 8.5375H20.0518L22.8972 13.3148H16.8215V9.00485V8.5375ZM0.0983137 15.288L0.696519 17.6767H1.2297C1.54805 16.5083 2.48281 15.5892 3.66102 15.288H0.0983137ZM4.4933 16.1189C3.13668 16.1189 2.04742 17.2041 2.04742 18.5594C2.04742 19.9147 3.13668 21 4.4933 21C5.85097 21 6.93814 19.9147 6.93814 18.5594C6.93814 17.2041 5.85097 16.1189 4.4933 16.1189ZM19.4744 16.1189C18.1168 16.1189 17.0296 17.2041 17.0296 18.5594C17.0296 19.9147 18.1168 21 19.4744 21C20.8321 21 21.9193 19.9147 21.9193 18.5594C21.9193 17.2041 20.8321 16.1189 19.4744 16.1189Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTow);
export default __webpack_public_path__ + "static/media/tow.0da4262878f3c18aa4d6a2b51df7afcc.svg";
export { ForwardRef as ReactComponent };